module.exports = __webpack_public_path__ + "static/media/image-1.697814a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/image-1.jpg
// module id = 277
// module chunks = 0